<template>
	<div id="login">
		<div class="login">
			<span class="dasai ds_guanbi2" @click="guanbi1()"></span>
			<div class="contentPart" id="contentPart">
				<div class="tel">
					<input type="tel" maxlength="11" placeholder="手机号" v-model="Mobile" id="phone"><button @click="checkPhone()" id="getcode">{{getcodetext}}</button>
				</div>
				<div class="numCode">
					<input type="tel" placeholder="验证码" id="code" v-model="code">
				</div>
				<button :disabled='disabled' class="getVoucher" id="getVoucher" @click="bindSuccess()">注册/登录</button>
			</div>
		</div>
	</div>
</template>

<script>
	import Bus from '../../assets/Bus.js'
	export default {
		data() {
			return {
				Mobile:'',
				code:'',
				countdown:60,
				getcodetext:"获取验证码",
				guanbi:0,
				disabled:false
			}
		},
		methods:{
			guanbi1(){
				this.$emit('guanbi',this.guanbi)
			},
			checkPhone(){
				// document.getElementById("getcode").setAttribute("disabled", true);
				this.axios.post('/api/SendCode', {
					Mobile:this.Mobile
				})
				.then(res => {
						console.log(res)
						if(res.data.Success){
							this.settime();
							this.$message({
							  message: '短信发送成功！',
							  type: 'success'
							});
						}else{
							this.$message.error(res.data.ErrorMsg);
						}
				})
				.catch(error => {
				  console.log(error)
				})
			},
			bindSuccess(){
				this.disabled = true
				this.axios.post('/api/Token', {
					Mobile:this.Mobile,
					Code:this.code
				})
				.then(res => {
						console.log(res)
						if(res.data.Success){
							this.settime();
							this.$emit('guanbi',this.guanbi)
							this.$message({
							  message: '登录成功！',
							  type: 'success'
							});
							
							localStorage.setItem('competition_cookie',res.data.data.token)
							localStorage.setItem('competition_info',JSON.stringify(res.data.data))
							var RegistType = res.data.RegistType
							var UserName = res.data.UserName
							Bus.$emit('UserName',UserName)
							window.history.go(0)
						}else{
							this.$message.error(res.data.ErrorMsg);
							this.disabled = false
						}
						
				})
				.catch(error => {
				  console.log(error)
				})
			},
			settime() {
				if (this.countdown == 0) {
					document.getElementById("getcode").removeAttribute("disabled");
					this.getcodetext="获取验证码";
					this.countdown = 60;
				} else {
					document.getElementById("getcode").setAttribute("disabled", true);
					this.getcodetext="重新发送(" + this.countdown + ")";
					this.countdown--;
					var that = this;
					setTimeout(function() {
						that.settime()
						console.log(111)
					},1000)
				}
				
			}
		},
	}
</script>

<style scoped="scoped" lang="scss">
	#login {
		position: fixed;
		width: 100vw;
		height: 100vh;
		background: rgba(0, 0, 0, 0.5);
		z-index: 2;
		top: 0;
		left: 0;
		.login {
			.ds_guanbi2{
				position: absolute;
				top: 6px;
				right: 10px;
				color: #fd0000;
				font-size: 18px;
			}
			position: absolute;
			top: 0;
			bottom: 0;
			right: 0;
			left: 0;
			margin: auto;
			background: #fff;
			border-radius: 10px;
			width: 380px;
			height: 240px;
			padding: 25px;
			.contentPart{
				div{
					margin-top: 20px;
				}
				input {
					width: 100%;
					line-height: 20px;
					padding: 8px 15px;
					box-sizing: border-box;
					border: 1px solid #d7d7d7;
					font-size: 14px;
				}
				.tel {
					position: relative;
					button {
						position: absolute;
						top: 3px;
						right: 5px;
						width: 115px;
						line-height: 28px;
						background: #009245;
						color: #fff;
						font-size: 14px;
						text-align: center;
					}
				}
				.getVoucher {
					line-height: 40px;
					background: #105ca3;
					text-align: center;
					color: #fff;
					display: block;
					width: 100%;
					margin-top: 15px;
					font-size: 16px;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/common/login.vue